import React, { useState } from "react";

import Helmet from "react-helmet";

import CustomButton from "../components/kits/button/CustomButton";

import EnterPhoneNumber from "../components/login/EnterPhoneNumber";
import VerifyCode from "../components/login/VerifyCode";

import "../components/login/login.scss";
// import ChatWidget from "../components/kits/chat_widget/ChatWidget";

interface LoginProps extends React.ComponentProps<typeof CustomButton> {}

const Login: React.FC<LoginProps> = ({ ...buttonProps }) => {
  const [step, setStep] = useState<number>(1);
  const [hashCode, setHashCode] = useState<string>("");
  const [mobile, setMobile] = useState<string>("");

  return (
    <>
      <Helmet>
        <title>خوش آمدید | ورود</title>
      </Helmet>
      <div className="login">
        <div className="login-container">
          {step === 1 ? (
            <EnterPhoneNumber
              mobile={mobile}
              setMobile={(state: string) => setMobile(state)}
              setStep={(state: number) => setStep(state)}
              setHashCode={(state: string) => setHashCode(state)}
            />
          ) : (
            <VerifyCode
              mobile={mobile}
              hashCode={hashCode}
              setStep={(state: number) => setStep(state)}
            />
          )}
        </div>
      </div>
      {/* <ChatWidget page={false} /> */}
    </>
  );
};

export default Login;
